import ContentHeader from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import "./../Expenses/Expenses.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASEURL } from "../../constant/constant";
import TransactionOfDay from "../../components/Transaction-comp/TransactionOfDay";
import TransactionOfDayNavigation from "../../components/Transaction-comp/Navigation/TransactionOfDayNavigation";
import { useLocation } from "react-router-dom";

const TransactionOfDayMain = () => {
  const { state } = useLocation();
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ofday_payment_list, setOfday_payment_list] = useState("");

  const OfDayPaymentList = async (showSkeleton = false) => {
    const auth_token = sessionStorage.getItem("auth_token");
    showSkeleton && setIsLoading(true);
    const response = await axios({
      url: BASEURL + "transaction/day",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: auth_token,
      },
      data: {
        day: state.day,
      },
    });
    setOfday_payment_list(response.data);
    showSkeleton && setIsLoading(false);
  };

  useEffect(() => {
    OfDayPaymentList(true);
  }, []);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <ContentHeader setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <TransactionOfDayNavigation />
        </div>
        <div className="content-index">
          <div className="content-scroll">
            <div class="content-card card">
              <TransactionOfDay
                ofday_payment_list={ofday_payment_list}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionOfDayMain;
